/* Anniversary Sale — nani. Vanilla, no dependencies. */
(function () {
  var root = document.querySelector('[data-anniv]');
  if (!root) return;

  var SIZE_ORDER = ['XS','S','M','L','XL','XXL','2X','3X','One Size'];
  var SORTS = [
    { key: 'name', label: 'Matching sets' },   /* titles lead with colorway, so A–Z pairs tops with their bottoms */
    { key: 'discount', label: 'Biggest saving' },
    { key: 'low', label: 'Price: low to high' },
    { key: 'high', label: 'Price: high to low' }
  ];
  var TIER_GROUPS = { faves: ['s2026', 's2025'], deepest: ['s2023', 'lastchance'] };
  var state = { tier: 'all', types: [], seasons: [], sizes: [], sort: 'name' };
  function tierMatch(tier) {
    if (state.tier === 'all') return true;
    if (state.tier === tier) return true;
    var group = TIER_GROUPS[state.tier];
    return !!group && group.indexOf(tier) > -1;
  }
  /* only grid-rail cards participate in filtering; the Top Faves rail is a fixed feature.
     These are (re)collected by collectFacets() — initially and after each Load More append. */
  var cards = [], typePaths = [], seasons = [], SIZES = [];

  /* ---------- countdown ---------- */
  var cd = root.querySelector('[data-anniv-countdown]');
  if (cd) {
    var startT = new Date(cd.getAttribute('data-target')).getTime();
    var endT = new Date(cd.getAttribute('data-target-end') || '').getTime();
    var labelEl = root.querySelector('[data-anniv-count-label]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var now = Date.now();
      /* before the sale: count down to open; during: count down to close */
      var live = !isNaN(endT) && now >= startT;
      var ms = Math.max(0, (live ? endT : startT) - now);
      var set = function (u, v) { var el = cd.querySelector('[data-unit="' + u + '"]'); if (el) el.textContent = pad(v); };
      set('d', Math.floor(ms / 86400000));
      set('h', Math.floor(ms / 3600000) % 24);
      set('m', Math.floor(ms / 60000) % 60);
      set('s', Math.floor(ms / 1000) % 60);
      if (labelEl) {
        var want = labelEl.getAttribute(live ? 'data-label-end' : 'data-label-pre') || '';
        if (want && labelEl.textContent !== want) labelEl.textContent = want;
      }
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- sticky offset under the theme header ---------- */
  var header = document.querySelector('.section-header, #shopify-section-header, header[role="banner"], .header-wrapper');
  if (header) root.style.setProperty('--anniv-header-offset', header.offsetHeight + 'px');

  /* ---------- filter chips built from what's actually rendered ---------- */
  function unique(list) { return list.filter(function (v, i) { return v && list.indexOf(v) === i; }); }
  /* hierarchical product-type paths: "Clothing - Tops - T-Shirts" */
  function collectFacets() {
    cards = [].slice.call(root.querySelectorAll('[data-anniv-grid] [data-card]'));
    typePaths = unique(cards.map(function (c) { return c.getAttribute('data-ptype'); })).sort();
    seasons = unique(cards.map(function (c) { return c.getAttribute('data-season'); }));
    seasons.sort(function (a, b) {
      var na = +a, nb = +b;
      if (isNaN(na) && isNaN(nb)) return a.localeCompare(b);
      if (isNaN(na)) return 1;               /* words (Evergreen) after years */
      if (isNaN(nb)) return -1;
      return nb - na;                        /* newest year first */
    });
    var sizesPresent = unique(cards.reduce(function (acc, c) {
      return acc.concat((c.getAttribute('data-sizes') || '').split('|'));
    }, []));
    SIZES = SIZE_ORDER.filter(function (s) { return sizesPresent.indexOf(s) > -1; })
      .concat(sizesPresent.filter(function (s) { return SIZE_ORDER.indexOf(s) === -1; }).sort());
  }
  collectFacets();
  function typeChildren(prefix) {
    var depth = prefix ? prefix.split(' - ').length : 0;
    var kids = [];
    typePaths.forEach(function (p) {
      if (prefix && p !== prefix && p.indexOf(prefix + ' - ') !== 0) return;
      var segs = p.split(' - ');
      if (segs.length > depth) {
        var k = segs.slice(0, depth + 1).join(' - ');
        if (kids.indexOf(k) === -1) kids.push(k);
      }
    });
    return kids.sort();
  }
  function renderTypeRows() {
    var host = root.querySelector('[data-anniv-types]');
    if (!host) return;
    host.innerHTML = '';

    function chip(path, label, row) {
      var active = state.types.indexOf(path) > -1;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'anniv-chip' + (active ? ' is-active' : '');
      b.textContent = label;
      b.addEventListener('click', function () {
        if (active) {
          /* deselect: also drop any deeper selections under this path */
          toggle(state.types, path);
          state.types = state.types.filter(function (t) { return t.indexOf(path + ' - ') !== 0; });
        } else {
          /* select: replace ancestors (so drilling narrows) and descendants (so broadening cleans up) */
          state.types = state.types.filter(function (t) {
            return path.indexOf(t + ' - ') !== 0 && t.indexOf(path + ' - ') !== 0;
          });
          state.types.push(path);
        }
        render();
      });
      row.appendChild(b);
    }

    /* group by top level: "Swim"/"Clothing" become titles, their sub-types stay visible */
    var groups = {}, flats = [];
    typePaths.forEach(function (p) {
      if (!p) return;
      var segs = p.split(' - ');
      if (segs.length === 1) { if (flats.indexOf(p) === -1) flats.push(p); return; }
      var g = segs[0], child = segs.slice(0, 2).join(' - ');
      groups[g] = groups[g] || [];
      if (groups[g].indexOf(child) === -1) groups[g].push(child);
    });

    Object.keys(groups).sort().forEach(function (g) {
      var lab = document.createElement('p');
      lab.className = 'anniv-typegroup';
      lab.textContent = g;
      host.appendChild(lab);
      var row = document.createElement('div');
      row.className = 'anniv-chiprow';
      groups[g].sort().forEach(function (childPath) {
        chip(childPath, childPath.split(' - ')[1], row);
      });
      host.appendChild(row);
      /* third level (e.g. T-Shirts under Clothing - Tops) appears while its parent is in play */
      groups[g].sort().forEach(function (childPath) {
        var kids = typeChildren(childPath);
        var show = kids.length && (state.types.indexOf(childPath) > -1 ||
          kids.some(function (k) { return state.types.indexOf(k) > -1; }));
        if (!show) return;
        var sub = document.createElement('div');
        sub.className = 'anniv-chiprow anniv-chiprow--sub';
        kids.forEach(function (kp) { chip(kp, kp.split(' - ').pop(), sub); });
        host.appendChild(sub);
      });
    });

    if (flats.length) {
      var row = document.createElement('div');
      row.className = 'anniv-chiprow';
      flats.sort().forEach(function (p) { chip(p, p, row); });
      host.appendChild(row);
    }
  }
  function chipRow(host, items, isActive, onPick) {
    host.innerHTML = '';
    items.forEach(function (item) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'anniv-chip' + (isActive(item) ? ' is-active' : '');
      b.textContent = item.label || item;
      b.addEventListener('click', function () { onPick(item); render(); });
      host.appendChild(b);
    });
  }

  function toggle(arr, v) {
    var i = arr.indexOf(v);
    if (i > -1) arr.splice(i, 1); else arr.push(v);
  }

  /* ---------- render ---------- */
  function matches(card) {
    if (state.types.length) {
      var pt = card.getAttribute('data-ptype') || '';
      var hit = state.types.some(function (p) { return pt === p || pt.indexOf(p + ' - ') === 0; });
      if (!hit) return false;
    }
    if (state.seasons.length && state.seasons.indexOf(card.getAttribute('data-season')) === -1) return false;
    if (state.sizes.length) {
      var have = (card.getAttribute('data-sizes') || '').split('|');
      var hit = state.sizes.some(function (s) { return have.indexOf(s) > -1; });
      if (!hit) return false;
    }
    return true;
  }

  function sortGrid(grid) {
    var items = [].slice.call(grid.querySelectorAll('[data-card]'));
    items.sort(function (a, b) {
      var pa = +a.getAttribute('data-price'), pb = +b.getAttribute('data-price');
      if (state.sort === 'low') return pa - pb;
      if (state.sort === 'high') return pb - pa;
      if (state.sort === 'name') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
      /* biggest saving: deepest % first, then price high to low */
      return (+b.getAttribute('data-pct') - +a.getAttribute('data-pct')) || (pb - pa);
    });
    items.forEach(function (el) { grid.appendChild(el); });
  }

  function render() {
    var total = 0;

    cards.forEach(function (c) {
      var ok = matches(c) && tierMatch(c.getAttribute('data-tier'));
      c.hidden = !ok;
      if (ok) total++;
    });

    var grid = root.querySelector('[data-anniv-grid]');
    if (grid) sortGrid(grid);

    root.querySelectorAll('[data-anniv-tier-chip]').forEach(function (b) {
      var k = b.getAttribute('data-anniv-tier-chip');
      b.classList.toggle('is-active', k === state.tier || (state.tier !== 'all' && k !== 'all' && tierMatch(k)));
      /* hide chips for tiers with nothing in the loaded collection */
      if (k !== 'all') b.hidden = !cards.some(function (c) { return c.getAttribute('data-tier') === k; });
    });
    root.querySelectorAll('[data-anniv-guide]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-anniv-guide') === state.tier);
    });

    var count = state.types.length + state.seasons.length + state.sizes.length;
    var fl = root.querySelector('[data-anniv-filter-label]');
    if (fl) fl.textContent = count ? 'Filters · ' + count : 'Filters';
    var fb = root.querySelector('[data-anniv-open-sheet]');
    if (fb) fb.classList.toggle('is-active', count > 0);
    var sl = root.querySelector('[data-anniv-sort-label]');
    if (sl) sl.textContent = (SORTS.filter(function (s) { return s.key === state.sort; })[0] || SORTS[0]).label.replace('Price: ', '');
    var rl = root.querySelector('[data-anniv-result]');
    if (rl) rl.textContent = total + (total === 1 ? ' style' : ' styles');
    var ap = root.querySelector('[data-anniv-apply]');
    if (ap) ap.textContent = 'Show ' + total + (total === 1 ? ' style' : ' styles');
    var empty = root.querySelector('[data-anniv-empty]');
    if (empty) empty.hidden = total > 0;

    renderTypeRows();
    chipRow(root.querySelector('[data-anniv-seasons]'), seasons,
      function (s) { return state.seasons.indexOf(s) > -1; },
      function (s) { toggle(state.seasons, s); });
    chipRow(root.querySelector('[data-anniv-sizes]'), SIZES,
      function (s) { return state.sizes.indexOf(s) > -1; },
      function (s) { toggle(state.sizes, s); });
    chipRow(root.querySelector('[data-anniv-sorts]'), SORTS,
      function (s) { return state.sort === s.key; },
      function (s) { state.sort = s.key; });
  }

  /* ---------- wiring ---------- */
  root.querySelectorAll('[data-anniv-tier-chip]').forEach(function (b) {
    b.addEventListener('click', function () { state.tier = b.getAttribute('data-anniv-tier-chip'); render(); });
  });
  var sheet = root.querySelector('[data-anniv-sheet]');
  root.querySelectorAll('[data-anniv-open-sheet]').forEach(function (b) {
    b.addEventListener('click', function () { if (sheet) sheet.hidden = false; });
  });
  root.querySelectorAll('[data-anniv-close-sheet]').forEach(function (b) {
    b.addEventListener('click', function () { if (sheet) sheet.hidden = true; });
  });
  root.querySelectorAll('[data-anniv-clear]').forEach(function (b) {
    b.addEventListener('click', function () { state = { tier: 'all', types: [], seasons: [], sizes: [], sort: 'name' }; render(); });
  });

  /* ---------- guide cards (quiz link handled by plain <a>) ---------- */
  root.querySelectorAll('[data-anniv-guide]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-anniv-guide');
      var faves = document.getElementById('anniv-faves');
      if (k === 'faves' && faves) {
        window.scrollTo({ top: faves.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
        return;
      }
      state.tier = state.tier === k ? 'all' : k;
      render();
      var grid = document.getElementById('anniv-grid');
      if (grid) window.scrollTo({ top: grid.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
    });
  });

  /* ---------- load more (fetches the next server page, appends into the rails) ---------- */
  var moreBtn = root.querySelector('[data-anniv-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var url = moreBtn.getAttribute('data-next-url');
      if (!url || moreBtn.disabled) return;
      moreBtn.disabled = true;
      var label = moreBtn.textContent;
      moreBtn.textContent = 'Loading…';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var remoteGrid = doc.querySelector('[data-anniv-grid]');
        var localGrid = root.querySelector('[data-anniv-grid]');
        if (remoteGrid && localGrid) {
          [].slice.call(remoteGrid.querySelectorAll('[data-card]')).forEach(function (c) { localGrid.appendChild(c); });
        }
        var remoteBtn = doc.querySelector('[data-anniv-more]');
        if (remoteBtn && remoteBtn.getAttribute('data-next-url')) {
          moreBtn.setAttribute('data-next-url', remoteBtn.getAttribute('data-next-url'));
          moreBtn.disabled = false;
          moreBtn.textContent = label;
        } else {
          var wrap = moreBtn.closest('.anniv-more');
          if (wrap) wrap.remove();
        }
        collectFacets();
        render();
      }).catch(function () {
        moreBtn.disabled = false;
        moreBtn.textContent = label;
      });
    });
  }

  render();
})();
